import { TestConfig } from "yup/lib/util/createValidation";
import { USStates } from "../../constants/USstates";

const normalize = (value: string): string =>
  value.trim().replace(/\s+/g, " ").toLowerCase();

// Set of normalized US state names and abbreviations that are not allowed as a
// standalone business/company name. Reusing the shared USStates constant keeps a
// single source of truth (includes DC and territories).
const STANDALONE_US_STATE_VALUES = new Set<string>();
USStates.forEach(state => {
  STANDALONE_US_STATE_VALUES.add(normalize(state.name));
  STANDALONE_US_STATE_VALUES.add(normalize(state.abbreviation));
});

/**
 * Yup test that rejects a value whose normalized form is exactly a US state name
 * or abbreviation (e.g. "California", "CA"). A state name combined with other
 * words is still allowed (e.g. "Colorado Dentists"). Used for legal business /
 * company name fields to prevent false-positive KYB matches (PLA-2097).
 */
export const getNotStandaloneUsStateTest = (
  errorMessage?: string
): TestConfig<string | undefined> => ({
  name: "notStandaloneUsState",
  message:
    errorMessage ||
    "Enter your full business name, not just a state name or abbreviation",
  test: (value: string | undefined) =>
    !value || !STANDALONE_US_STATE_VALUES.has(normalize(value))
});
